import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/final-cta.css';

const FinalCTA = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="final-cta-section">
      <div className="final-cta-container">
        <div className="final-cta-content">
          <h2 className="final-cta-title">
            ¿Listo para encontrar tu herramienta ideal?
          </h2>
          <p className="final-cta-text">
            Explorá nuestro catálogo completo de productos STIHL y descubrí 
            la calidad profesional que merecés
          </p>
          <Link 
            to="/productos" 
            className="final-cta-button"
            onClick={scrollToTop}
          >
            Ver todo el catálogo →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;